import Vue from 'vue'
import axios from 'axios'
import Amplify, { Auth } from 'aws-amplify';
import awsconfig from './aws-exports';
Amplify.configure(awsconfig);


import App from './App.vue'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import '../node_modules/material-design-icons-iconfont/dist/material-design-icons.css'


Vue.component('frame-auth', '')


Vue.use(axios)
Vue.use(Auth)

Vue.config.productionTip = false;

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app');

